<template>
  <!-- radix-vue primitives default to ltr; pass the locale direction so menus/selects mirror in RTL -->
  <ConfigProvider :dir="isRTL ? 'rtl' : 'ltr'">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </ConfigProvider>
</template>

<script setup>
import { ConfigProvider } from "radix-vue";
import { riseIn } from "~/utils/motion";

const { locale } = useI18n();
const isRTL = useIsRtl();

// Add dir and lang attributes to html (getters keep them in sync when the
// locale changes client-side)
useHead({
  htmlAttrs: {
    dir: () => (isRTL.value ? "rtl" : "ltr"),
    lang: () => locale.value,
  },
});

// Canonical, hreflang, robots, title template and default Open Graph tags
// (see composables/useSeoHead.ts).
useSeoHead();

// Each new page fades and rises in once it has rendered. A <Transition mode="out-in">
// would take the old page away first and leave the area blank while the next page
// loads; this way Nuxt keeps the old page up until the new one is ready.
const nuxtApp = useNuxtApp();
nuxtApp.hook("page:finish", () => {
  if (nuxtApp.isHydrating) return;
  // Layout pages render inside <main>; layout-less ones (the landing) at the root.
  const page = document.getElementById("main-content")?.firstElementChild ?? document.getElementById("__nuxt")?.firstElementChild;
  riseIn(page, { y: 8, stagger: 0 });
});
</script>
